import classNames from 'classnames';
import Typography from 'components/generics/texts/Typography';
import useFullName from 'hooks/requests/kyc/useFullName';
import usePortfolio from 'hooks/requests/portfolio/usePortfolio';
import Image from 'next/image';
import { getCorrectIllustration } from 'pages/profile/components/ProfileHeader/utils';
import pluralize from 'pluralize';
import React, { HTMLAttributes } from 'react';
import Skeleton from 'react-loading-skeleton';
import classes from './index.module.scss';
import useUserDetails from '../../../../hooks/requests/user/hooks/useUserDetails';

const ProfileHeader = ({ className }: HTMLAttributes<HTMLDivElement>) => {
  const { portfolio } = usePortfolio();
  const { isTenant } = useUserDetails();
  const sharesNumber = portfolio?.shares;
  const propertiesNumber = portfolio?.properties?.length;
  const Icon = getCorrectIllustration(sharesNumber);
  const fullName = useFullName();

  return (
    <div className={classNames(className, classes.container)}>
      <div className={classes.imageContainer}>
        {Icon ? (
          <Image
            className={classes.image}
            src={Icon}
            alt="Level Icon"
            fill
          />
        ) : (
          <Skeleton
            width={200}
            height={120}
            style={{
              borderRadius: 20,
            }}
          />
        )}
      </div>
      <div>
        {fullName ? (
          <Typography className={classes.name}>{fullName}</Typography>
        ) : (
          <Skeleton
            width={160}
            height={30}
            style={{ marginBottom: 10 }}
          />
        )}
        {!isTenant &&
          (portfolio ? (
            <Typography className={classes.description}>
              {pluralize('SHARE', sharesNumber, true)} ∙{' '}
              {pluralize('PROPERTY', propertiesNumber, true)}
            </Typography>
          ) : (
            <Skeleton
              width={'100%'}
              height={15}
            />
          ))}
      </div>
    </div>
  );
};

export default ProfileHeader;
